import {
  offerDefinitionDetailsTranslation,
  OfferDefinitionDetailsTranslation,
} from '@/assets/locales/views/offerDefinitions/details/offerDefinitionDetails.translation.pl.ts';
import {
  offerDefinitionsListTranslation,
  OfferDefinitionsListTranslation,
} from '@/assets/locales/views/offerDefinitions/list/offerDefinitionsList.translation.pl.ts';

export type OfferDefinitionsTranslation = {
  details: OfferDefinitionDetailsTranslation;
  list: OfferDefinitionsListTranslation;
};

export const offerDefinitionsTranslation: OfferDefinitionsTranslation = {
  details: offerDefinitionDetailsTranslation,
  list: offerDefinitionsListTranslation,
};
